import React from "react";
import { Typography, Box, Button, Grid, Card, List, ListItem, ListItemText } from "@mui/material";
import TriangleBackground from "../layout/TriangleBackground";
import LogoIcon from "../../assets/logo.png"; // your logo
import Slider from "react-slick"; // make sure to install react-slick and slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


// Example icons
import WebIcon from "@mui/icons-material/Web";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CloudIcon from "@mui/icons-material/Cloud";
import StorageIcon from "@mui/icons-material/Storage";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import careerimge from "../../assets/images/careerimg.jpeg";
const Careers = ({ mode }) => {
    const DColors = ["#FF69B4", "#35ca35", "#FFA500", "#00BFFF"]; // pink, green, orange, blue




    const textSegments = [
        { letter: "CAREERS ", color: DColors[0] },
        { text: "at " },
        { letter: "O", color: DColors[1] },
        { text: "lyvia " },
        { letter: "T", color: DColors[2] },
        { text: "ech " },
        { letter: "S", color: DColors[3] },
        { text: "olutions" },
    ];

    // Example services array
    const services = [
        {
            title: "Web Development",
            icon: <WebIcon fontSize="large" color="primary" />,
            points: ["Responsive websites", "Modern UI/UX", "SEO-friendly"],
        },
        {
            title: "Mobile Development",
            icon: <PhoneIphoneIcon fontSize="large" color="primary" />,
            points: ["iOS & Android apps", "Cross-platform", "Performance optimized"],
        },
        {
            title: "Cloud Computing",
            icon: <CloudIcon fontSize="large" color="primary" />,
            points: ["AWS, Azure, GCP", "Scalable infrastructure", "Serverless options"],
        },
        {
            title: "Middleware",
            icon: <StorageIcon fontSize="large" color="primary" />,
            points: ["Integration services", "APIs & messaging", "Data pipelines"],
        },
        {
            title: "GenAI",
            icon: <SmartToyIcon fontSize="large" color="primary" />,
            points: ["AI-powered solutions", "Automation", "Chatbots & NLP"],
        },
    ];

    // Slider settings
    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 900, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }, // Add more granular breakpoint for smaller devices
        ],
    };


    return (
        <div>
            {/* === Hero Section with Triangle Background === */}
            <TriangleBackground mode={mode}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "column" },
                        alignItems: "center",
                        justifyContent: "center",
                        px: 2,
                        gap: 4,
                        height: "100%",
                        width: "100%"
                    }}
                >
                    {/* Content on the left */}
                    <Box
                        sx={{
                            width: { xs: "100%", md: "100%" },
                            textAlign: { xs: "center", md: "center" },
                        }}
                    >

                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: "bold",
                                mb: 2,
                                color: mode === "dark" ? "#fff" : "#000",
                            }}
                        >
                            {textSegments.map((seg, idx) =>
                                seg.letter ? (
                                    <span key={idx} style={{ color: seg.color }}>
                                        {seg.letter}
                                    </span>
                                ) : (
                                    <span key={idx}>{seg.text}</span>
                                )
                            )}
                        </Typography>

                        <Typography
                            variant="h4"

                            sx={{ color: mode === "dark" ? "#ccc" : "#444" }}
                        >
                            We are engineers, designers, marketers and gamers
                            who are shaping the future digitally
                        </Typography>
                    </Box>

                    {/* Logo on the right */}
                    {/* <Box
            component="img"
            src={LogoIcon}
            alt="Olyviatech Logo"
            className="spin-fade-logo"
            sx={{
              width: { xs: 120, sm: 150, md: 250 },
              height: "auto",
            }}
          /> */}
                </Box>
            </TriangleBackground>


            {/* === CTA Section: Have a Question? === */}
            <section
                style={{
                    position: "relative",
                    padding: "120px 20px",
                    backgroundColor: "#000", // force dark background for stars
                    overflow: "hidden",
                }}
            >
                {/* Animated stars background */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `
        radial-gradient(white 1px, transparent 1px),
        radial-gradient(white 1px, transparent 1px)
      `,
                        backgroundSize: "40px 40px",
                        backgroundPosition: "0 0, 20px 20px",
                        animation: "moveStars 60s linear infinite",
                        opacity: 0.5,
                        zIndex: 0,
                    }}
                />

                {/* Foreground content */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        maxWidth: "800px",
                        mx: "auto",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: "bold",
                            color: "#fff",
                            mb: 4,
                        }}
                    >
                        Let's Build Together
                    </Typography>

                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: "bold",
                            color: "#fff",
                            mb: 4,
                        }}
                    >
                        We are looking for people to join our team of smart, fun, curious and creative people who are excited to help build a platform that empowers the future.
                    </Typography>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "blue",
                            color: "#ffff",
                            fontWeight: "bold",
                            px: 5,
                            py: 1.5,
                            fontSize: "1rem",
                            borderRadius: "8px",
                            '&:hover': {
                                backgroundColor: "#43a047",
                            },
                        }}
                    >
                        Open Positions →
                    </Button>
                </Box>
            </section>
            <section
                style={{
                    position: "relative",
                    padding: "120px 20px",
                    backgroundColor: "#000", // force dark background for stars
                    overflow: "hidden",
                }}
            >
                {/* Animated stars background */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `
        radial-gradient(white 1px, transparent 1px),
        radial-gradient(white 1px, transparent 1px)
      `,
                        backgroundSize: "40px 40px",
                        backgroundPosition: "0 0, 20px 20px",
                        animation: "moveStars 60s linear infinite",
                        opacity: 0.5,
                        zIndex: 0,
                    }}
                />

                {/* Foreground content */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        maxWidth: "800px",
                        mx: "auto",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: "bold",
                            color: "#fff",
                            mb: 4,
                        }}
                    >
                        Have a question? We're happy to help
                    </Typography>

                    <Button
                        variant="contained"
                        href="/contact"
                        sx={{
                            backgroundColor: "#4caf50",
                            color: "#ffff",
                            fontWeight: "bold",
                            px: 5,
                            py: 1.5,
                            fontSize: "1rem",
                            borderRadius: "8px",
                            '&:hover': {
                                backgroundColor: "#43a047",
                            },
                        }}
                    >
                        Contact Us →
                    </Button>
                </Box>
            </section>




            {/* <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Careers
        </Typography>
        <Typography variant="body1">[ Add careers info here ]</Typography>
      </section>

      <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Contact Us
        </Typography>
        <Typography variant="body1">[ Add contact form here ]</Typography>
      </section> */}
        </div>
    );
};

export default Careers;
